import { StyledImage } from "@/shared/components/StyledImageComponent/StyledImageComponent";
import ENV from "../../env";

const Background: React.FC = () => {
  return (
    <div className="bg-container absolute inset-0 overflow-hidden">
      <StyledImage type="background" rootApiPath={ENV.API_SERVER} className="styled-image absolute inset-0 w-full h-full" />
    </div>
  );
};

export default Background;
